import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_PRE_PROPOSAL,
  GET_PRE_PROPOSAL_BY_HASH,
  UPDATE_PRE_PROPOSAL,
  PENDING_PRE_PROPOSAL,
  APPROVE_PRE_PROPOSAL,
} from './actionType';

const INIT_STATE = {
  preProposals: [],
  preProposalByHash: {},
  error: {},
  success: null,
  loading: true,
};

const ValidationOfProposals = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRE_PROPOSAL:
          return {
            ...state,
            preProposals: action.payload.data,
            success: null,
            error: {},
            preProposalByHash: {},
            loading: false,
          };
        case GET_PRE_PROPOSAL_BY_HASH:
          return {
            ...state,
            preProposalByHash: action.payload.data,
            success: null,
            error: {},
          };
        case UPDATE_PRE_PROPOSAL:
          return {
            ...state,
            success: 'Successfully updated pre proposal',
            error: {},
          };
        case PENDING_PRE_PROPOSAL:
          return {
            ...state,
            success: 'Successfully pending pre proposal',
            error: {},
          };
        case APPROVE_PRE_PROPOSAL:
          return {
            ...state,
            success: 'Successfully approved pre proposal',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_PRE_PROPOSAL:
          return {
            ...state,
            success: '',
            error: action.payload.error,
            loading: false,
          };
        case GET_PRE_PROPOSAL_BY_HASH:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case UPDATE_PRE_PROPOSAL:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case PENDING_PRE_PROPOSAL:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case APPROVE_PRE_PROPOSAL: {
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        }
        default:
          return { ...state };
      }
    case GET_PRE_PROPOSAL: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_PRE_PROPOSAL_BY_HASH: {
      return {
        ...state,
      };
    }
    case UPDATE_PRE_PROPOSAL: {
      return {
        ...state,
      };
    }
    case PENDING_PRE_PROPOSAL: {
      return {
        ...state,
      };
    }
    case APPROVE_PRE_PROPOSAL: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default ValidationOfProposals;
